import type { PropsWithChildren } from 'react';

const EmptyContainer = ({ children }: PropsWithChildren<{}>) => {
    return <div className="bg-neutral-0 flex w-full justify-center rounded-xl sm:p-24">{children}</div>;
};

export default EmptyContainer;
